$(document).ready(() => {

    const buttons = $('.non-featured-categories');

    let filterActive = false;

    buttons.on('click', '.filter-category', function (event) {
        event.preventDefault();

        let elementsToFilter = [];

        // manage the active state of the buttons
        buttons
            .find('.filter-category')
            .not($(event.currentTarget))
            .removeClass('is-active');

        $(event.currentTarget).toggleClass('is-active');

        // determine active state
        filterActive = buttons.find('.filter-category').hasClass('is-active');

        // get the slider instance for later reuse
        const slider = $(event.currentTarget)
            .parents('.non-featured-categories')
            .next()
            .find('.slick-slider.slick-initialized');

        // reset the filtered elements
        slider.slick('slickUnfilter');

        // if there is no active filter, we can abort at this point
        if (!filterActive) {
            return;
        }

        // get all elements of the slider
        const sliderElements = $(event.currentTarget)
            .parents('.non-featured-categories')
            .next()
            .find('.widget-product-carousel .product');

        // iterate over all array values (e.g. category ids) of the clicked button
        $.each($(event.currentTarget).data('category-id'), function(index, value) {

            // iterate over all sliderElements
            $.each(sliderElements, function(index, sliderElement) {

                // push all matching elements onto an array
                if ($.inArray(value, $(sliderElement).data('category-id')) >= 0) {
                    elementsToFilter.push($(sliderElement).parents('.slick-slide'));
                }
            });
        });

        // do the actual filtering of the elements
        slider.slick(
            'slickFilter',
            $(elementsToFilter).map(function() {
                return this.toArray();
            })
        );
    });
});
